import React from 'react';

import classes from './Input.css';

const input = props => {

    let inputElement = null;

    const inputClasses = [classes.InputElement];

    if (props.invalid && props.shouldValidate ) {
        inputClasses.push(classes.Invalid);

    }

   
    switch (props.elementType) {
        case ('input'): 
            inputElement = 
                <div className={classes.InputWrapper}>
                    <p>{props.name}</p>
                    <input className={inputClasses.join(' ')}
                        {...props.elementConfig} value={props.value}
                        onChange={props.changed} />
                </div>
            break
        case ('textarea'):
            inputElement = <textarea className={classes.TextArea}
                {...props.elementConfig} value={props.value}
                onChange={props.changed} />
            break
        case('timeAndDate'):
            inputElement = 
                <div className={classes.DateWrapper}>
                    <p>Release Date: </p>
                    <input className={inputClasses}
                    {...props.elementConfig} value={props.value}
                    onChange={props.changed}/>
                </div>
            break;
        default: 
            inputElement = <input className={inputClasses} 
                {...props.elementConfig} value={props.value} />
    }



    let validationError = null;
    if (props.invalid && props.touched){
        validationError = <p className={classes.ValidationError}>
            {props.errorMessage}
        </p>
    }



    return (
        <div className={classes.InputElement} >
            <label className={classes.Label}>
                {props.label}
            </label>
            {inputElement}
            {validationError}
        </div>
    )
}

export default input;


// WEBPACK FOOTER //
// ./src/components/UI/Input/Input.js